import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MEDIA_STUDIO_SETTINGS_TABS } from '../../../../constants';

const useMediaTabs = () => {
  const { t } = useTranslation('settings');

  const TABS = useMemo(
    () => [
      { label: t('mediaStudioImages'), index: MEDIA_STUDIO_SETTINGS_TABS.IMAGES },
      { label: t('mediaStudioFonts'), index: MEDIA_STUDIO_SETTINGS_TABS.FONTS },
      { label: t('mediaStudioBrandColors'), index: MEDIA_STUDIO_SETTINGS_TABS.COLORS },
    ],
    [t],
  );

  return TABS;
};

export default useMediaTabs;
